import { useNavigate } from "react-router-dom";
import { Briefcase, Handshake, User, Package, Wrench, Calculator, Truck, Percent, FileText, Newspaper, LayoutDashboard } from "lucide-react";
import {
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
} from "./ui/dropdown-menu";
import useConfirmedEmployers from "../lib/useConfirmedEmployers";
import { setApiEmployer } from "../lib/api";
import { EMPLOYER_MODULES, rememberEmployerContext } from "../lib/employerModules";

// Icon je echter Modulseite (EMPLOYER_MODULES kennt nur Label/Pfad/Recht).
const PATH_ICON = {
    "/dealer/workshop-orders": Wrench,
    "/dealer/wms": Package,
    "/dealer/invoices": FileText,
    "/dealer/disposition": Truck,
    "/dealer/buchhaltung": Calculator,
    "/intranet": Newspaper,
};

/**
 * WorkspaceMenuSection — Vermittler-Bereiche INNERHALB der Header-Haupt-Dropdown.
 * „Vermittler & Verkäufer-Dashboard": Übersicht + Vermittlung & Verkauf + Privat.
 * „Firmen-Bereich": je bestätigtem Arbeitgeber dessen Einträge FLACH als
 * Hauptpunkte (Firmen-Übersicht, Provisionen, echte Module im Arbeitgeber-Kontext).
 */
export default function WorkspaceMenuSection({ user }) {
    const navigate = useNavigate();
    const employers = useConfirmedEmployers(user);

    if (!user || user === false || user.role !== "vermittler") {
        return null;
    }

    // Echtes Händler-Modul im Arbeitgeber-Kontext öffnen.
    const openModule = (e, path) => {
        setApiEmployer(e.dealer_id);
        rememberEmployerContext(e);
        navigate(path);
    };

    return (
        <>
            <DropdownMenuSeparator />
            <DropdownMenuLabel className="text-[10px] uppercase tracking-wider text-gray-400">Vermittler &amp; Verkäufer-Dashboard</DropdownMenuLabel>
            <DropdownMenuItem onClick={() => navigate("/vermittler")} data-testid="menu-vermittler">
                <LayoutDashboard className="w-4 h-4 mr-2" /> Dashboard-Übersicht
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => navigate("/vermittler?view=vermittlung")} data-testid="workspace-vermittlung">
                <Handshake className="w-4 h-4 mr-2" /> Vermittlung &amp; Verkauf
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => navigate("/vermittler?view=privat")} data-testid="workspace-privat">
                <User className="w-4 h-4 mr-2" /> Privat
            </DropdownMenuItem>

            {employers.length > 0 && (
                <>
                    <DropdownMenuSeparator />
                    <DropdownMenuLabel className="text-[10px] uppercase tracking-wider text-gray-400">Firmen-Bereich</DropdownMenuLabel>
                    {employers.map((e) => {
                        const perms = e.permissions || [];
                        const mods = EMPLOYER_MODULES.filter((m) => m.perm == null || perms.includes(m.perm));
                        return (
                            <div key={e.dealer_id}>
                                <DropdownMenuLabel className="flex items-center gap-2 text-[11px] font-bold text-gray-700 pt-2 pb-0.5">
                                    <Briefcase className="w-4 h-4 text-[#FFCC00]" /> {e.dealer_name}
                                </DropdownMenuLabel>
                                <DropdownMenuItem
                                    onClick={() => navigate(`/vermittler?view=firma&firma=${e.dealer_id}`)}
                                    data-testid={`workspace-firma-${e.dealer_id}`}
                                >
                                    <Briefcase className="w-4 h-4 mr-2" /> Firmen-Übersicht
                                </DropdownMenuItem>
                                <DropdownMenuItem
                                    onClick={() => navigate(`/vermittler?view=firma&firma=${e.dealer_id}&mod=provisionen`)}
                                    data-testid={`workspace-firma-${e.dealer_id}-provisionen`}
                                >
                                    <Percent className="w-4 h-4 mr-2" /> Meine Provisionen
                                </DropdownMenuItem>
                                {mods.map((m) => {
                                    const Icon = PATH_ICON[m.path] || Briefcase;
                                    return (
                                        <DropdownMenuItem
                                            key={m.path}
                                            onClick={() => openModule(e, m.path)}
                                            data-testid={`workspace-firma-${e.dealer_id}-mod-${m.path.replace(/\//g, "-").replace(/^-/, "")}`}
                                        >
                                            <Icon className="w-4 h-4 mr-2" /> {m.label}
                                        </DropdownMenuItem>
                                    );
                                })}
                            </div>
                        );
                    })}
                </>
            )}
        </>
    );
}
